<app-larged-tuile
  icon="fa-kit fa-picto-pac"
  [title]="
    (actionStack!.getValue('paPModeRegulation') === 0
      ? 'P00043.dashboard.card.title.warm'
      : 'P00043.dashboard.card.title.cold'
    ) | translate
  "
  [buttons]="buttons"
  [status]="
    buttonMode[this.actionStack!.getValue('paSCommande')].title! | translate
  "
  [mode]="getTemperature(actionStack!.getValue('paPConsigneTemperature'), 0)"
  [statusMode]="
    this.actionStack!.getValue('paSAlarme') === 1
      ? 'alarm'
      : buttonMode[this.actionStack!.getValue('paSCommande')].status!
  "
  [selectItem]="this.actionStack!.getValue('paCModeFonctionnement')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PAC_Control,
      'paCModeFonctionnement',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
